export const canAmendOffer = (loanType, offer, loan) => {
  if (!offer?.id) return false;
  const statuses = loanType === "corporate"
    ? ["pending", "pending_document_request", "rejected", "accepted"]
    : ["pending_borrower_action", "borrower_renegotiation", "borrower_rejected",
      "awaiting_lender_documents", "pending_borrower_signature",
      "pending_lender_confirmation", "revision_requested", "pending_disbursement"];
  if (!statuses.includes(offer.status)) return false;
  if (offer.disbursement_date || offer.repayment_schedules?.length || offer.repaymentSchedules?.length) return false;
  if (loan && (!['pending', 'pending_amendment'].includes(loan.status) || loan.receipt || loan.repayments?.length)) return false;
  return true;
};
